import { saveLifeCycle } from '@/constants/lifecycle';

const datasetSettingActions = {
  CLOSE_DATASET_SETTINGS: 'CLOSE_DATASET_SETTINGS',
  FETCH_DATASET_SETTINGS: 'FETCH_DATASET_SETTINGS',
  FETCH_DATASET_SETTINGS_ERROR: 'FETCH_DATASET_SETTINGS_ERROR',
  FETCH_DATASET_SETTINGS_SUCCESS: 'FETCH_DATASET_SETTINGS_SUCCESS',
  HIDE_CATALOGUE_CONFIRMATION: 'HIDE_CATALOGUE_CONFIRMATION',
  HIDE_DATASET_TYPE_WIZARD_CONFIRMATION: 'HIDE_DATASET_TYPE_WIZARD_CONFIRMATION',
  HIDE_EDIT_COHORT_SETTINGS: 'HIDE_EDIT_COHORT_SETTINGS',
  HIDE_WORKFLOW_CONFIRMATION: 'HIDE_WORKFLOW_CONFIRMATION',
  SHOW_CATALOGUE_CONFIRMATION: 'SHOW_CATALOGUE_CONFIRMATION',
  SHOW_DATASET_TYPE_WIZARD_CONFIRMATION: 'SHOW_DATASET_TYPE_WIZARD_CONFIRMATION',
  SHOW_EDIT_COHORT_SETTINGS: 'SHOW_EDIT_COHORT_SETTINGS',
  SHOW_WORKFLOW_CONFIRMATION: 'SHOW_WORKFLOW_CONFIRMATION',
  SWITCH_DATASET_TYPE: 'SWITCH_DATASET_TYPE',
  TOGGLE_DATASET_SETTING: 'TOGGLE_DATASET_SETTING',
  UPDATE_COHORT_SETTINGS_PROPERTIES: 'UPDATE_COHORT_SETTINGS_PROPERTIES',
  UPDATE_DATASET_SETTINGS: 'UPDATE_DATASET_SETTINGS',
  UPDATE_DATASET_SETTINGS_ERROR: 'UPDATE_DATASET_SETTINGS_ERROR',
  UPDATE_DATASET_SETTINGS_PROPERTIES: 'UPDATE_DATASET_SETTINGS_PROPERTIES',
  UPDATE_DATASET_SETTINGS_SUCCESS: 'UPDATE_DATASET_SETTINGS_SUCCESS',
  UPDATE_DATASET_SETTINGS_PANELS: 'UPDATE_DATASET_SETTINGS_PANELS',
};

export const datasetTransferTypes = {
  CLEAR: 'allow_clear',
  PMN: 'allow_pseudonymised',
  MANUAL: 'allow_manual',
  TOKEN: 'allow_token',
};

export const automatedDatasetTransferTypes = {
  CLEAR: datasetTransferTypes.CLEAR,
  PMN: datasetTransferTypes.PMN,
};

export const datasetSettingsCategories = ['open'];

export const datasetSettingsLifeCycle = [
  'readStatus',
  'readErrors',
  ...saveLifeCycle,
];

export default datasetSettingActions;
